

















































































































































































































































































































































































































































































































































import NonCommodityContractAddressWidget from '@/components/widgets/NonCommodityContractAddressWidget.vue';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';
import Component from 'vue-class-component';
import vSelect from 'vue-select';
import _ from 'lodash';

@Component({
  components: {
    'v-select': vSelect
  }
})
export default class ContractAddressWidget extends NonCommodityContractAddressWidget {
  public hideInputBirthday: boolean = true;

  public showTooltip: boolean = false;

  protected fieldIdentifiers: string[] = [
    'first-name',
    'surname',
    this.hideInputBirthday ? '' : 'birthday',
    'email',
    'zip',
    'city',
    'street',
    'houseNumber',
    'billing-business-name',
    'taxId',
    'taxNumber',
    'billingZip',
    'billingCity',
    'billingStreet',
    'billingHouseNumber'
  ];

  protected fieldIdentifiersMandatory: string[] = [
    'first-name',
    'surname',
    this.hideInputBirthday ? '' : 'birthday',
    'email',
    'zip',
    'city',
    'street',
    'houseNumber',
    'billing-business-name',
    'taxId',
    'taxNumber',
    'billingZip',
    'billingCity',
    'billingStreet',
    'billingHouseNumber'
  ];

  protected afterSaveDateOfBirth(): void {
    const that = this;
    setTimeout(function () {
      that.updateFieldDisplayForElement(that.$el.querySelector('#birthday'));
    }, 1);
  }

  protected getExtendedFieldStatusClass(
    classes: string[],
    fieldId: string,
    fieldValue: string,
    ignoreInvalidAndEmpty: boolean = false,
    isRecursive: boolean = false
  ): string[] {
    if (fieldId == 'taxId') {
      if (!fieldValue || fieldValue.length == 0) {
        if (this.taxNumber && this.taxNumber.length > 0) {
          const emptyIndex: number = classes.indexOf('field-empty');
          if (emptyIndex >= 0) {
            classes.splice(emptyIndex, 1);
          }
          const emptyMandatoryIndex: number = classes.indexOf('field-mandatory-empty');
          if (emptyMandatoryIndex >= 0) {
            classes.splice(emptyMandatoryIndex, 1);
          }
        }
      }
      if (!isRecursive) {
        this.updateFieldDisplayForElement(this.$el.querySelector('#taxNumber'), ignoreInvalidAndEmpty, false, true);
      }
    }
    if (fieldId == 'taxNumber') {
      if (!fieldValue || fieldValue.length == 0) {
        if (this.vatId && this.vatId.length > 0) {
          const emptyIndex: number = classes.indexOf('field-empty');
          if (emptyIndex >= 0) {
            classes.splice(emptyIndex, 1);
          }
          const emptyMandatoryIndex: number = classes.indexOf('field-mandatory-empty');
          if (emptyMandatoryIndex >= 0) {
            classes.splice(emptyMandatoryIndex, 1);
          }
        }
      }
      if (!isRecursive) {
        this.updateFieldDisplayForElement(this.$el.querySelector('#taxId'), ignoreInvalidAndEmpty, false, true);
      }
    }
    return classes;
  }

  created(): void {
    this.extendedData = _.merge(
      {
        [this.extendedDataParentKey]: {
          TAX_NUMBER_MULTI: '',
          VAT_ID_MULTIYEAR: ''
        }
      },
      this.store.state.journey_session.extendedData
    );

    if (
      this.extendedData[this.extendedDataParentKey] &&
      this.extendedData[this.extendedDataParentKey].ACCOUNTING_INDICATOR_MULTI
    ) {
      this.vwGroupAffiliationValue =
        this.vwGroupAffiliation.find(
          (item) => item.value == this.extendedData[this.extendedDataParentKey].ACCOUNTING_INDICATOR_MULTI
        ) ?? null;
    }
  }

  get isCustomerBusiness(): boolean {
    if (this.isFleetFlow) {
      return true;
    }
    return this.sessionState.business == 1;
  }

  get isCustomerPrivate(): boolean {
    return this.sessionState.business == 0;
  }

  get isProductAvailableForBusiness(): boolean {
    return NonCommodityProductFacade.isProductAvailableForBusiness(
      this.store.state.nonCommodityProductData.productCode
    );
  }

  get b2bProduct(): Record<any, any> {
    return this.store.getters.getB2BProduct || {};
  }

  get vwGroupAffiliation(): { label: string; value: string }[] {
    return [
      {
        label: this.$t('contract.widget.group.affiliation.normal').toString(),
        value: 'Normal'
      },
      {
        label: this.$t('contract.widget.group.affiliation.affiliated.company').toString(),
        value: 'Verbundenes Unternehmen'
      },
      {
        label: this.$t('contract.widget.group.affiliation.vw.group').toString(),
        value: 'Umsatzsteuerorganschaft'
      }
    ];
  }
  public onGroupAffiliationInput(group: { label: string; value: string }): void {
    this.vwGroupAffiliationValue = group;
    this.updateFieldDisplayForElement(this.$el.querySelector('#group_affiliation'));
    this.extendedData[this.extendedDataParentKey].ACCOUNTING_INDICATOR_MULTI = group.value;
    this.store.dispatch('setSessionExtendedData', {
      [this.extendedDataParentKey]: { ACCOUNTING_INDICATOR_MULTI: group.value }
    });
    this.checkIsFormComplete();
  }

  public dataModifierHook(): Record<any, any> {
    if (!this.sessionState.billingAlternativeAddress) {
      this.setInputValue('billingSalutation', '');
      this.setInputValue('billingFirstName', '');
      this.setInputValue('billingSurname', '');
      this.setInputValue('billingZip', '');
      this.setInputValue('billingCity', '');
      this.setInputValue('billingStreet', '');
      this.setInputValue('billingHouseNumber', '');
    } else {
      this.setInputValue('billingSalutation', '9');
      this.setInputValue('billingFirstName', this.sessionState.firstName ?? '');
      this.setInputValue('billingSurname', this.sessionState.firstName ?? '');
      this.setInputValue('billingSalutation', this.sessionState.salutation ?? '');
    }
    if (!this.sessionState.business) {
      this.setInputValue('billingCompany', '');
      this.store.dispatch('setSessionExtendedData', {
        [this.extendedDataParentKey]: { TAX_NUMBER_MULTI: '', VAT_ID_MULTIYEAR: '' }
      });
    }
    return {
      ...this.sessionState,
      genericStorage: null
    };
  }
}
